//TODO test
export default class Environment {
  public static isInMemory(): boolean {
    const isInMemory = Environment.getRequestParam("inMemoryData") === "true";
    console.info("is in memory? ", isInMemory);
    return isInMemory;
  }

  public static getHost(): string {
    if (window.location.href.indexOf("localhost:") !== -1) {
        // return "https://lrv-mobile-backend-prd.azurewebsites.net";
      return "http://localhost:8089";
    } else if (window.location.href.indexOf("app-dev") !== -1) {
      return "https://lrv-mobile-backend-dev.azurewebsites.net";
    } else {
      return "https://lrv-mobile-backend-prd.azurewebsites.net";
    }
  }

  public static getWebAppHost(): string {
    if (window.location.href.indexOf("localhost:3000") !== -1) {
      return "http://localhost:3000";
    } else if (window.location.href.indexOf("localhost:8100") !== -1) {
      return "http://localhost:8100";
    } else if (window.location.href.indexOf("app-dev") !== -1) {
      return "https://lrv-mobile-app-dev.azurewebsites.net";
    } else {
      return "https://lrv-mobile-app-prd.azurewebsites.net";
    }
  }

  private static getRequestParam(paramName: string) {
    const url_string = window.location.href;
    const url = new URL(url_string);
    return url.searchParams.get(paramName);
  }
}
